import React, { useEffect, useState } from "react";
import Checkout from "@system/config/checkout";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import liveAuth from "src/helper/liveAuth";
import System from "src/helper/system";
import { useCartStore } from "src/hooks/cart";
import { isNumber } from "underscore";
import StripPriceLoader from "src/component/Global/StripPriceLoader";
import Constants from "src/helper/Constants";
import { useProductStore } from "src/hooks/product";
import { Tooltip } from "src/component/Global/Tooltip";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import { __set, __remove } from "src/store/axios_indicator";
import useReduxState from "src/hooks/useReduxState";
import { profileStore } from "src/hooks/profile";

const CartShippingDetail = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ CART_DATA, CART_SUB_TOTAL, VALIDATE_CART, CART_BEFORE_TO_SEND_SERVER }, { }, { },] = useCartStore();
  const [{ productList }, { }, { }] = useProductStore();
  const [disableBtn, setDisableBtn] = useState(false)
  const [{ inventoryList }, { get_inventory_by_id, get_exchange_rate }, { },] = useProductInventoryPriceStore();
  const [load, setLoad] = useState(false)
  const [exchangeRate, setExchangeRate] = useState(1)
  const [checkoutClicked, setCheckoutClicked] = useReduxState(false, 'checkoutConfirmation')
  const { ACCOUNTINACTIVE, RESTRICTEDCOUNTRY, INVALIDITEMPRICE } = Constants
  const authLoggedIn = liveAuth.check();
  const { translation: t, storageName: { CART_CHECKOUT, CART_PRODUCT_DATA } } = System;
  const [{ profile_user_information }, { get_profile_account_information }, { }] = profileStore();

  useEffect(() => {
    let disableCheckout = false
    if (authLoggedIn === false) {
      disableCheckout = false
    } else {
      if (VALIDATE_CART && Object.keys(VALIDATE_CART)?.length > 0) {
        Object.entries(VALIDATE_CART?.validation).map(obj => {
          if (![ACCOUNTINACTIVE, RESTRICTEDCOUNTRY, INVALIDITEMPRICE].includes(obj[0])) {
            disableCheckout = true
          }
        })
      }

      if (CART_DATA && Object.entries(CART_DATA)?.length > 0) {
        Object.entries(CART_DATA).filter((itm) => {
          let productQty = get_inventory_by_id(itm[1]?.itemNumber).totalInventory
          if (itm[1]?.subtotal <= 0 || itm[1]?.unitPrice <= 0) {
            disableCheckout = true
          }
          if (Object.entries(inventoryList)?.length > 0 && (itm[1].quantity > productQty) === true && itm[1].backOrderedQuantity === 0) {
            disableCheckout = true
          }
          if (CART_BEFORE_TO_SEND_SERVER[itm[1]?.itemNumber]?.invalid_quantity) {
            disableCheckout = true;
          }
          if (itm[1]?.isProductAvailableFromMainAPI === false) {
            disableCheckout = true;
          }
        });
      }
    }

    if (Object.entries(CART_DATA)?.length === 0) {
      disableCheckout = true
    }

    setDisableBtn(disableCheckout)
  }, [VALIDATE_CART, CART_DATA, inventoryList, CART_BEFORE_TO_SEND_SERVER])

  useEffect(() => {
    async function fetchExchangeRate() {
      __set('EXCHANGE_RATE_API_CALL')
      let exchangeCurrencyRate = await get_exchange_rate({ inputCurrency: window.mct })
      __remove('EXCHANGE_RATE_API_CALL')
      setExchangeRate(exchangeCurrencyRate)
    }

    async function fetchHere() {
      await get_profile_account_information();
    }

    if ((System.avUserInfoData.currentUser === Constants.siteUser.WEB && !System.validateDomain(System.avUserInfoData.email))) {
      fetchHere()
    }
    fetchExchangeRate()

  }, [])

  useEffect(() => {
    if (checkoutClicked === true) {
      setCheckoutClicked(false)
      __set('CHECKOUT_CALL')
      let list = {}
      const idSet = Object.keys(CART_DATA).map(ele => ele)
      Object.entries(productList).filter(ele => {
        if (idSet.includes(ele[0])) {
          const data = { [ele[0]]: ele[1] }
          list = { ...list, ...data }
        }
      })
      localStorage.setItem(CART_CHECKOUT, true);
      localStorage.setItem(System.storageName.CART_PRODUCT_DATA, JSON.stringify(list))
      setLoad(true);
      window.location.href = Checkout.getCheckOutRouteURL();
    }
  }, [checkoutClicked])

  const checkOutActionMaker = () => {
    let validate = true
    if (disableBtn === false) {
      if (authLoggedIn === false) {
        System.popup("GuestPopupActionButton", {
          title: t('requestToCheckout'),
          body: t('signInToCheckout'),
          yesButton: t('signInRegister'), closeButton: t('cancel')
        });
        return;
      }


      if (VALIDATE_CART && Object.keys(VALIDATE_CART)?.length > 0) {
        Object.entries(VALIDATE_CART?.validation).map(obj => {
          if (obj[0] === ACCOUNTINACTIVE) {
            setDisableBtn(true)
            validate = false
            System.popup('ThankYouPopup', { isAccountInActive: true });
          }

        })
      }

      if (validate) {
        VALIDATE_CART?.validation && (Object.keys(VALIDATE_CART?.validation)?.length > 0 && Object.keys(VALIDATE_CART?.validation)?.includes(RESTRICTEDCOUNTRY)) ? System.popup('CheckoutConfirmationPopup') :
          (((System.avUserInfoData.currentUser === Constants.siteUser.WEB && !System.validateDomain(System.avUserInfoData.email)) && profile_user_information?.company === null) ?
            System.popup('ContactInformationPopup', { msg: 'contactInformation', setCheckoutClicked, isFrom: Constants.systemModules.CART }) :
            setCheckoutClicked(true))
      }
    }
    return false;
  };

  return (
    <>
      {__check(["VIEW_CART_API_CALL", "CART_API_CALL", "CART_OPERATION_API_CALL", "EXCHANGE_RATE_API_CALL"]).status ?
        <StripPriceLoader />
        :
        <>
          <div className="cart-shopping-detail">
            <div className="cart-shipping-detail">
              <div className="bs5 row">

                <div className="col-12">
                  <div className="bs5 row m-0 mini-cart-item-total">
                    <div className="col-7 px-0">
                      <span>
                        <span className="cart-item-count">({Object.entries(CART_DATA)?.length}){" "}</span>
                        {t('itemsSubtotal')}:
                      </span>
                    </div>
                    <div className="col-5 text-end font_bold_currency ps-1">
                      <span className="font_bold_currency">
                        {System.getFormatNumber({ amount: Number(CART_SUB_TOTAL), currency: System.getRegionCurrency(), roundOff: true }) || 0}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
              <div className="bs5 row">
                <div className="col-7">
                  <span>{t('estimatedShipping')}: </span>
                </div>
                <div className="col-5 text-end font_bold_currency">
                  <span>--</span>
                </div>
              </div>
              {/* <div className="bs5 row font_bold_currency">
                <div className="col-7">
                  <span>Estimated Tax: </span>
                </div>
                <div className="col-5 text-end ">
                  <span>--</span>
                </div>
              </div> */}
            </div>

            <div className="bs5 row m-0">
              <div className="order-total" >
                <div className="bs5 row font_bold_currency">
                  <div className="col-6">
                    <span>{t('orderTotal')} </span>
                  </div>
                  <div className="col-6 text-end">
                    <div>
                      <span className='subtotal-currency'>{System.getRegionCurrency()}</span>
                      <span className="ms-1">
                        {isNumber(CART_SUB_TOTAL) ? System.getFormatNumber({ amount: Number(CART_SUB_TOTAL), maximumFractionDigits: 2, isDisplaySymbol: false, currency: System.getRegionCurrency(), roundOff: true }) || 0 : ""}
                      </span>
                    </div>
                    {window.mct != System.getRegionCurrency() && <div className="mt-1">
                      <span className='subtotal-currency text-black-stone'>{window.mct}</span>
                      <span className="ms-1 text-black-stone">
                        {isNumber(CART_SUB_TOTAL) ? System.getFormatNumber({ amount: Number(CART_SUB_TOTAL) * exchangeRate, maximumFractionDigits: 2, isDisplaySymbol: false, roundOff: true }) || 0 : ""}
                      </span>
                    </div>}
                  </div>
                </div>
              </div>
            </div>

            <div className="shopping-option text-center">
              {!__check(["CART_API_CALL", "CART_OPERATION_API_CALL", "VIEW_CART_API_CALL"]).status && (
                disableBtn ? (
                  <Tooltip
                    opener={() =>
                      <a href={void 0} className={`bs5 btn btn-primary d-block most-viewd-item-btn m-auto disabled ${load && 'h-30'}`} disabled>
                        <div className='d-flex align-items-center justify-content-center line-height-20'>
                          <span className="fa add-cart-lock-icon me-1" /> {t('checkout')}
                        </div>
                      </a>
                    }
                    content={() => t('reviewCartBeforeCheckout')}
                  />

                ) : (
                  <a href={void 0} className={`bs5 btn btn-primary d-block most-viewd-item-btn m-auto ${load && 'h-30'}`}
                    onClick={(e) => { load ? e.preventDefault() : checkOutActionMaker(); }}>
                    <div className='d-flex align-items-center justify-content-center line-height-20'>
                      {load ? (
                        <div>
                          <i className="fa fa-spinner fa-spin" />
                        </div>
                      ) : (
                        <>
                          <span className="fa add-cart-lock-icon me-1" /> {t('checkout')}
                        </>
                      )}
                    </div>
                  </a>

                )
              )}

              <div className="text-center d-flex align-items-center justify-content-center">
                <a href={System.getHomepageUrl()} className="my-2" >
                  {t('continueShopping')}
                </a>
              </div>
              <span className="instruction text-black-stone">
                {t('vatAndShippingWillBeCalculatedLater')}
              </span>
            </div>
          </div>
        </>
      }
    </>
  );
};

export default CartShippingDetail;

